import { render, staticRenderFns } from "./PayPurchaseService.vue?vue&type=template&id=08f6a342&scoped=true"
import script from "./PayPurchaseService.vue?vue&type=script&lang=ts"
export * from "./PayPurchaseService.vue?vue&type=script&lang=ts"
import style0 from "./PayPurchaseService.vue?vue&type=style&index=0&id=08f6a342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6a342",
  null
  
)

export default component.exports